import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from "@angular/forms";
import { MatDialogRef, MatDialog } from "@angular/material";
import { DistributorOrderEditFormComponent } from "../distributor-order/distributor-order-edit-form/distributor-order-edit-form.component";
import { DataTableComponent } from "../datatable/datatable.component";
import { AppService } from "../../services/app.service";
import { MasterService } from "../../services/master.service";
import { FinanceService } from "../../services/finance.service";
import { OrderService } from "../../services/order.service";
import { ComponentService } from '../../services/component.service';
import { SharedService } from "../../services/shared";
import { Datatable } from "../../models/datatable.model";
import { AjaxService } from "../../../../core/services/ajax.service";

@Component({
  selector: 'app-finance-shipper',
  templateUrl: './finance-shipper.component.html',
  styleUrls: ['./finance-shipper.component.scss']
})

export class FinanceShipperComponent implements OnInit {
	@ViewChild('inpFromWeekNumber') inpFromWeekNumber: ElementRef;
	@ViewChild('inpFromYear') inpFromYear: ElementRef;
	@ViewChild('inpToWeekNumber') inpToWeekNumber: ElementRef;
	@ViewChild('inpToYear') inpToYear: ElementRef;
	@ViewChild('inpOrderStatus') inpOrderStatus;
	@ViewChild('inpShippers') inpShippers;
	@ViewChild('chipActionPdf') chipActionPdf;
	@ViewChild('chipActionMail') chipActionMail;
    @ViewChild('inpCountryCode') inpCountryCode;
	@ViewChild('chipActionExcel') chipActionExcel;

	editFormDialogRef: MatDialogRef<DistributorOrderEditFormComponent>;
	public data = [];
	order: any;
	pdf: any;

	currentDate: any;
	translations: any = [];
	orderStatusList: any = [];
	shippersList: any = [];

	weekNumber: Number = 0;
	year: Number = 0;
	orderStatusId: Number;
	shipperId: Number;
	filterText: string = "";
	length: Number = 0;

	totalCOD: Number = 0;
	totalTransInvAmt: Number = 0;
	totalRevenue: Number = 0;

	formGroup: FormGroup;
    formGroupErrors: any;
    countryList: any = [];
    countryId: Number;

    gridMessage: string = '';

  	constructor(
  		private formBuilder: FormBuilder, 
  			public dialog: MatDialog, 
  				public orderService: OrderService, 
  					public financeService: FinanceService, 
  						public appService: AppService, 
  							public masterService : MasterService, 
  								private datatableComponent: DataTableComponent, 
  									private datatableProp: Datatable, 
  										private sharedService: SharedService,
  											private comService: ComponentService,
                                                private _ajaxService: AjaxService) { 
		this.formGroupErrors = {
	      Status: {},
	      Shipper: {}
	    };
  	}

	ngOnInit() {
		this.currentDate = new Date();
		this.bindOrderStatus();
	}

	 ngAfterViewInit(){
	 	this.toggleHeaderButtons(true);
	 }
	 exportToExcel(){
		this.appService.showLoading();
		this.financeService.exportToPdf(this.inpFromWeekNumber.nativeElement.value, this.inpFromYear.nativeElement.value, this.inpToWeekNumber.nativeElement.value, this.inpToYear.nativeElement.value, this.inpOrderStatus.value, this.inpShippers.value,this.inpCountryCode.value).subscribe(
	        res => this.exportToExcelSuccess(res),
	        error => this.apiFaillure(error)
	    )
	 }
	exportToPdf(){
		this.appService.showLoading();
		this.financeService.exportToPdf(this.inpFromWeekNumber.nativeElement.value, this.inpFromYear.nativeElement.value, this.inpToWeekNumber.nativeElement.value, this.inpToYear.nativeElement.value, this.inpOrderStatus.value, this.inpShippers.value,this.inpCountryCode.value).subscribe(
	        res => this.exportToPdfSuccess(res),
	        error => this.apiFaillure(error)
	    );
	}

	exportToPdfSuccess(res){
		this.appService.hideLoading();
		if(res.Data != null){
			window.open(res.Data, '_blank');
		}
	}

	exportToExcelSuccess(res){
		this.appService.hideLoading();
		if(res.Data != null){
			res.Data = res.Data.replace(".pdf",".xlsx");
			window.open(res.Data, '_blank');
		}
	}

	sendSfReport(){
		this.appService.showLoading();
		this.financeService.sendSfReport(this.inpFromWeekNumber.nativeElement.value, this.inpFromYear.nativeElement.value, this.inpToWeekNumber.nativeElement.value, this.inpToYear.nativeElement.value, this.inpOrderStatus.value, this.inpShippers.value,this.inpCountryCode.value).subscribe(
	        res => this.sendSfReportSuccess(res),
	        error => this.apiFaillure(error)
	    );
	}

	sendSfReportSuccess(res){
		this.appService.hideLoading();
		if(res.Status == 1)
			this.appService.showDialogue(this.translations.hdSuccess, this.translations.msgEmailSent);
		else
			this.appService.showDialogue(this.translations.hdError, this.translations.msgEmailNotSent);

	}

	getFinanceOrders(): void {
	    this.appService.showLoading();
	    var fromNum = this.inpFromWeekNumber.nativeElement.value == '' ? '0' : this.inpFromWeekNumber.nativeElement.value;
	    var fromYr = this.inpFromYear.nativeElement.value == '' ? '0' : this.inpFromYear.nativeElement.value;
	    var toNum = this.inpToWeekNumber.nativeElement.value == '' ? '0' : this.inpToWeekNumber.nativeElement.value;
	    var toYr = this.inpToYear.nativeElement.value == '' ? '0' : this.inpToYear.nativeElement.value;
	    this.financeService.selectShipper(fromNum, fromYr, toNum, toYr, this.inpOrderStatus.value, this.inpShippers.value,this.inpCountryCode.value).subscribe(
	        res => this.getFinanceOrdersSuccess(res),
	        error => this.apiFaillure(error)
	    );
	}

	getFinanceOrdersSuccess(res): void {
		this.appService.hideLoading();
	    this.data = [];
	    this.sharedService.Data.next(this.data);
	    if (res.Status == 1) {
	      this.data = JSON.parse(res.Data).Table;

	      	if(this.data.length > 0){
			    this.datatableProp = this.appService.mapDataTableProp(this.datatableProp, JSON.parse(res.Data).Table1[0]);
			    this.datatableProp.gridControl = JSON.parse(res.Data).Table2;
			    this.dataChanged();
		    }else
		    	this.data = JSON.parse(res.Data).Table;
		    this.setGridMessage();	
		    this.sharedService.Data.next(this.data);
	      	this.appService.hideLoading();
	    } else if (res.Status == -1) {
	      this.apiFaillure(res.Message);
	    }
	}

	setGridMessage(){
		if(this.data.length == 0){
			this.gridMessage = this.translations.msgNoData;
		}else{
			this.gridMessage = '';
		}
	}

	setPageTranslations() {
	  this.comService.get('finance').subscribe((res) => {
	      this.translations = JSON.parse(res['Data']);
	      this.appService.hideLoading();
	  });
	}

	go(){
		this.getFinanceOrders();
	}

	bindOrderStatus(): void {
		this.appService.showLoading();
	    this.masterService.selectSysData("OrderStatus","").subscribe(
	        res => this.getOrderStatusSuccess(res),
	        error => this.apiFaillure(error)
	    );
	}

	getOrderStatusSuccess(res): void {
	    if (res.Data != null) {
	      this.setPageTranslations();	
	      this.orderStatusList = JSON.parse(res.Data);
	      this.inpOrderStatus.value = this.inpOrderStatus.value == undefined ? 0 : this.inpOrderStatus.value;
	      this.orderStatusId = this.inpOrderStatus.value;	
            this.bindShippers();
            
	    } else {
	      this.apiFaillure(res.Message);
	    }
	}

	bindShippers(): void {
	    this.financeService.selectShippers().subscribe(
	        res => this.bindShippersSuccess(res),
	        error => this.apiFaillure(error)
	    );
	}

	bindShippersSuccess(res): void {
	    if (res.Data != null) {
	      this.setPageTranslations();	
	      this.shippersList = JSON.parse(res.Data).Table;
		  if(this.shippersList.length > 0){
			this.inpShippers .value = this.inpShippers.value == undefined ? this.shippersList[0]['Id'] : this.inpShippers.value;
		  }
	      
	      this.shipperId = this.inpShippers.value;
	      this.dataChanged();
            this.getCountries();
	      ;
	    } else {
	      this.apiFaillure(res.Message);
	    }
	}

	apiFaillure(error): void {
		this.appService.showDialogue(
			this.translations.hdError,
			this.translations[error]
		);
	}

	applyFilter(filterValue: any) {
	    this.datatableProp = new Datatable();
	    this.filterText = filterValue;
	    this.getFinanceOrders();
	}

	getDataArray(row, columns){
		var arr_data = [];
		for(var i = 0; i < columns.length; i++){
			var column_data = row[columns[i]] != undefined ? row[columns[i]] : '';
			arr_data.push(column_data);
		}
		return arr_data;
	}

	getTotal(header){
		var total = 0;
		if(this.data != undefined && this.data.length > 0){
			for(var i = 0; i < this.data.length; i++){			
				total += this.data[i][header];
			}						
		}
		return total;
	}

	editRecord(e): void {
	    this.appService.showLoading();
	    this.orderService.select(e.currentTarget.id).subscribe(
	        res => this.selectSuccess(res),
	        error => this.apiFaillure(error)
	    );
	}

  	selectSuccess(res): void {
	    if (res.Status == 1) {
	      this.order = JSON.parse(res.Data)[0];
	      this.editFormDialogRef = this.dialog.open(DistributorOrderEditFormComponent, {
	        disableClose: true,
	        data: this.order,
	        panelClass: "my-dialog"
	      });
	      this.editFormDialogRef.afterClosed().subscribe(response => {
	        this.appService.showLoading();
	        this.data = [];
	        this.sharedService.Data.next(this.data);
	        this.bindOrderStatus();
	      });
	    } else if (res.Status == -1) {
	      this.apiFaillure(res.Message);
	    }
  	}

  	disableActions(){
  		if(this.chipActionPdf != undefined && this.chipActionMail != undefined && this.chipActionExcel != undefined){
  			this.chipActionPdf.disabled = true;
	  		this.chipActionMail.disabled = true;
			this.chipActionExcel.disabled = true;
	  		this.toggleHeaderButtons(true);
  		}
  	}

  	toggleHeaderButtons(flag){
  		var backgroundColor = flag ? 'lightgrey': '#1e88e5';
  		this.chipActionPdf._elementRef.nativeElement.setAttribute('style','background:'+ backgroundColor +';');
	  	this.chipActionMail._elementRef.nativeElement.setAttribute('style','background:'+ backgroundColor +';');
		  this.chipActionExcel._elementRef.nativeElement.setAttribute('style','background:'+backgroundColor+';');
  	}

  	dataChanged(){
  		if(this.chipActionPdf != undefined && this.chipActionMail != undefined && this.chipActionExcel != undefined){
	  		if(this.inpShippers.value == 0){
		  		this.chipActionPdf.disabled = true;
		  		this.chipActionMail.disabled = true;
				  this.chipActionExcel.disabled = true;
		  		this.toggleHeaderButtons(true);
	  		}else{
	  			this.chipActionPdf.disabled = false;
		  		this.chipActionMail.disabled = false;
				this.chipActionExcel.disabled = false;
		  		this.toggleHeaderButtons(false);
	  		}
  		}
  	}
    
getCountries(){
    this._ajaxService.GET("Master.svc/mastercountrycodelist").subscribe(response => {
        this.countryList = JSON.parse(response.Data);
        this.inpCountryCode.value = this.inpCountryCode.value == undefined ? 0 : this.inpCountryCode.value;
        this.countryId = this.inpCountryCode.value;
        this.getFinanceOrders();
    });
}

}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/finance-shipper/finance-shipper.component.ts